import { axiosInstance } from '@/plugins/axios';

// 验证二维码是否准确
// 默认action name为手机验证码，
const imageCodeVerify = ({
  actionName = 'candao.user.sendPhoneResetPasswdVerific',
  imgCode = '',
  params = { type: 2 },
  ...data
}) => axiosInstance({
  method: 'post',
  url: 'CodeAction',
  params: {
    code: imgCode,
    _name: actionName,
    ...params,
  },
  data: {
    actionName,
    ...data,
  },
});

// 手机绑定获取验证码
const bindVerificCode = ({
  actionName = 'candao.user.sendPhoneBindVerificCode',
  ...data
}) => axiosInstance({
  method: 'post',
  url: 'Action',
  data: {
    actionName,
    ...data,
  },
});

export default {
  imageCodeVerify,
  bindVerificCode,
};
